module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"prolongationFailed":"The last attempt to extend your subscription was unsuccessful. Please choose another card and click Retry button.","youCan":"You can","replaceActiveCard":"Change active card","tryToCharge":"Try to pay again with an active card","prolongSubscription":"Extend subscription","change":"Change"}}')
  delete Component.options._Ctor
}
